import React from 'react'
import SectionCard from '../../shared/SectionCard'
import StarRating from '../../shared/StarRating'
import './style.css'

const Testimonials = ({ testimonials }) => {
    return (
        <SectionCard icon="mdi:format-quote-close" titleKey="testimonials">
            <div className="testimonials-list">
                {testimonials?.map(testimonial => (
                    <div key={testimonial.id} className="testimonial-card">
                        <div className="testimonial-header">
                            <img 
                                src={testimonial.avatar} 
                                alt={testimonial.author} 
                                className="testimonial-avatar"
                                onError={(e) => e.target.src = './images/avatar-placeholder.jpg'}
                            />
                            <div className="testimonial-author-info">
                                <div className="testimonial-author-name">{testimonial.author}</div>
                                <StarRating rating={testimonial.rating} />
                            </div>
                        </div>
                        <p className="testimonial-text">"{testimonial.text}"</p>
                    </div>
                ))}
            </div>
        </SectionCard>
    )
}

export default Testimonials

